import { useState } from "react";

interface SlideoutState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

interface EventSlideouts {
  resources: SlideoutState;
  members: SlideoutState;
  chat: SlideoutState;
  eventTimes: SlideoutState;
}

export const useEventSlideouts = (): EventSlideouts => {
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const [isMembersOpen, setIsMembersOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isEventTimesOpen, setIsEventTimesOpen] = useState(false);

  return {
    chat: {
      close: () => setIsChatOpen(false),
      isOpen: isChatOpen,
      open: () => setIsChatOpen(true),
    },
    eventTimes: {
      close: () => setIsEventTimesOpen(false),
      isOpen: isEventTimesOpen,
      open: () => setIsEventTimesOpen(true),
    },
    members: {
      close: () => setIsMembersOpen(false),
      isOpen: isMembersOpen,
      open: () => setIsMembersOpen(true),
    },
    resources: {
      close: () => setIsResourcesOpen(false),
      isOpen: isResourcesOpen,
      open: () => setIsResourcesOpen(true),
    },
  };
};
